<app-config-workspace-buttons></app-config-workspace-buttons>

<h2>Target System Mapping</h2>

<button mat-raised-button color="accent" (click)="downloadTemplateMapping()">Download CSV</button>

<table class="table table-borderless">
  <thead>
  <tr>
    <th>Source</th>
    <th>Business Unit</th>
    <th>Payload</th>
    <th>Target System</th>
    <th>Supported</th>
    <th>Source Schema</th>
    <th>Transform</th>
    <th>Enrich</th>
    <th>Combine</th>
    <th>Encapsulate</th>
    <th>Format Transformation</th>
    <th>Target Schema</th>
    <th>Target</th>
    <th>Retrieve Schema</th>
    <th>Submit Schema</th>
    <th>Target Params</th>
    <th>2nd Target</th>
    <th></th>
  </tr>
  </thead>
  <tr *ngFor="let item of mappings"
      [ngClass]="isReferencedByConfig(item) ? 'referenced' : isAvailableToConfig(item) ? '' : 'unreferenced'">
    <td>{{item.sourceSystem}}</td>
    <td>{{item.businessUnit}}</td>
    <td>{{item.payloadType}}</td>
    <td>{{item.targetSystem}}</td>
    <td>
      <mat-select [(value)]="item.supported" (valueChange)="updateItem(item)" [disabled]="!canEditSupportedStatus">
        <mat-option *ngFor="let mode of supportedConfigMode" [value]="mode">{{mode}}</mat-option>
      </mat-select>
    </td>
    <td>
      <mat-select class="schema" [(value)]="item.sparrowSchema" (valueChange)="updateItem(item)"
                  [disabled]="!canEditMappings">
        <mat-option *ngFor="let mode of schemas" [value]="mode">{{mode}}</mat-option>
      </mat-select>
    </td>
    <td>
      <mat-select class="transform" [(value)]="item.transform" (valueChange)="updateItem(item)"
                  [disabled]="!canEditMappings">
        <mat-option *ngFor="let mode of transforms" [value]="mode">{{mode}}</mat-option>
      </mat-select>
    </td>
    <td>
      <mat-select class="transform" [(value)]="item.enrich" (valueChange)="updateItem(item)"
                  [disabled]="!canEditMappings">
        <mat-option *ngFor="let mode of transforms" [value]="mode">{{mode}}</mat-option>
      </mat-select>
    </td>
    <td>
      <mat-select class="transform" [(value)]="item.combine" (valueChange)="updateItem(item)"
                  [disabled]="!canEditMappings">
        <mat-option *ngFor="let mode of transforms" [value]="mode">{{mode}}</mat-option>
      </mat-select>
    </td>
    <td>
      <mat-select class="transform" [(value)]="item.encapsulate" (valueChange)="updateItem(item)"
                  [disabled]="!canEditMappings">
        <mat-option *ngFor="let mode of transforms" [value]="mode">{{mode}}</mat-option>
      </mat-select>
    </td>
    <td>
      <mat-select class="transform" [(value)]="item.formatTransformation" (valueChange)="updateItem(item)"
                  [disabled]="!canEditMappings">
        <mat-option *ngFor="let format of supportedformatTransformations" [value]="format">{{format}}</mat-option>
      </mat-select>
    </td>
    <td>
      <mat-select class="schema" [(value)]="item.soloSchema" (valueChange)="updateItem(item)"
                  [disabled]="!canEditMappings">
        <mat-option *ngFor="let mode of schemas" [value]="mode">{{mode}}</mat-option>
      </mat-select>
    </td>
    <td>
      <mat-select class="target" [(value)]="item.target" (valueChange)="updateItem(item)" [disabled]="!canEditTargetSystem">
        <mat-option *ngFor="let target of supportedTargets" [value]="target.value">{{target.display}}</mat-option>
      </mat-select>
    </td>
    <td>
      <input class="params" matInput type="text" (blur)="updateItem(item)" [(ngModel)]="item.regxchangeRetrieveSchema"
             [readonly]="!canEditTargetSystem">
    </td>
    <td>
      <input class="params" matInput type="text" (blur)="updateItem(item)" [(ngModel)]="item.regxchangeSubmitSchema"
             [readonly]="!canEditTargetSystem">
    </td>
    <td>
      <input class="params" matInput type="text" (blur)="updateItem(item)" [(ngModel)]="item.targetParams"
             [readonly]="!canEditTargetSystem">
    </td>
    <td>
      <mat-select class="target" [(value)]="item.secondTarget" (valueChange)="updateItem(item)" [disabled]="!canEditTargetSystem">
        <mat-option *ngFor="let target of supportedTargets" [value]="target.value">{{target.display}}</mat-option>
      </mat-select>
    </td>
    <td>
      <button mat-raised-button color="accent" (click)="restore(item)"
              [disabled]="item.state === 'original'">Restore
      </button>
    </td>
  </tr>
</table>
